"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          fontFamily:
            'var(--font-body, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif)',
          backgroundColor: "var(--surface-wash)",
          color: "var(--text-primary)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          padding: "1rem",
        }}
      >
        <div
          style={{
            maxWidth: "28rem",
            width: "100%",
            padding: "2rem",
            textAlign: "center",
            backgroundColor: "var(--surface-elevated)",
            border: "1px solid var(--border-hairline)",
            borderRadius: "var(--radius-xl)",
            boxShadow: "var(--shadow-frame)",
          }}
        >
          <div
            aria-hidden="true"
            style={{
              alignItems: "center",
              backgroundColor:
                "color-mix(in oklch, var(--status-danger) 12%, transparent)",
              border: "1px solid var(--status-danger)",
              borderRadius: "var(--radius-pill)",
              color: "var(--status-danger)",
              display: "inline-flex",
              fontSize: "1.25rem",
              fontWeight: 700,
              height: "2.5rem",
              justifyContent: "center",
              marginBottom: "1rem",
              width: "2.5rem",
            }}
          >
            !
          </div>
          <h1
            style={{
              fontSize: "1.125rem",
              fontWeight: 600,
              color: "var(--text-primary)",
              marginBottom: "0.5rem",
            }}
          >
            Something went wrong
          </h1>
          <p style={{ color: "var(--text-secondary)", marginBottom: "1.5rem" }}>
            An unexpected error occurred. Please try again or return to the home
            page.
          </p>
          <div
            style={{
              display: "flex",
              gap: "0.5rem",
              justifyContent: "center",
            }}
          >
            <button
              onClick={() => reset()}
              style={{
                padding: "0.5rem 1rem",
                fontSize: "0.875rem",
                fontWeight: 500,
                color: "var(--brand-on-primary)",
                backgroundColor: "var(--brand-primary)",
                border: "none",
                borderRadius: "var(--radius-button)",
                cursor: "pointer",
              }}
            >
              Try Again
            </button>
            <button
              onClick={() => (window.location.href = "/")}
              style={{
                padding: "0.5rem 1rem",
                fontSize: "0.875rem",
                fontWeight: 500,
                color: "var(--text-primary)",
                backgroundColor: "transparent",
                border: "1px solid var(--border-hairline)",
                borderRadius: "var(--radius-button)",
                cursor: "pointer",
              }}
            >
              Go Home
            </button>
          </div>
          <p
            style={{
              marginTop: "1.5rem",
              fontSize: "0.75rem",
              color: "var(--text-muted)",
            }}
          >
            Contractor Co-Pilot
          </p>
        </div>
      </body>
    </html>
  );
}
